// @flow
import React from 'react'
import { Link } from 'react-router-dom'

export const PasswordChangeError = (): any => {
  return (
    <div className='pw-reset-password'>
      <span className='login__accent' />
      <div className='login__header'>
        <h3 className='login__title'>Something went wrong</h3>
        <h4 className='login__subtitle'>There was a problem changing your password. Please wait a few minutes and try again.</h4>
      </div>
      <Link to='/' className='pw-reset-password__login'>Return to Login Page</Link>
    </div>
  )
}

PasswordChangeError.displayName = 'PasswordChangeError'

export default PasswordChangeError
